import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Cable, Loader2 } from "lucide-react";

export default function RegisterPage() {
  const { t } = useTranslation();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    company_name: "", admin_name: "", admin_email: "", admin_password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    const res = await register(form);
    setLoading(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-5">
      <div className="relative hidden lg:col-span-3 lg:block">
        <img
          src="https://images.pexels.com/photos/2420212/pexels-photo-2420212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Fiber"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-950/60" />
        <div className="absolute inset-0 flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-2">
            <div className="grid h-10 w-10 place-items-center rounded-sm bg-[#0052FF]">
              <Cable className="h-5 w-5" />
            </div>
            <span className="font-mono text-sm tracking-widest">EVOSOFT</span>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-slate-300">{t("auto.nuova_azienda")}</div>
            <h1 className="mt-2 text-4xl font-bold leading-tight lg:text-5xl">Attiva il tuo ambiente cloud in 30 secondi.</h1>
            <p className="mt-4 max-w-md text-slate-300">
              Nessun setup. Materiali di consumo, committenti (FiberCop, OpenFiber) e listino base pronti all'uso. Aggiungi tecnici e collaboratori subito dopo.
            </p>
          </div>
        </div>
      </div>

      <div className="col-span-1 flex items-center justify-center bg-white px-6 py-12 lg:col-span-2">
        <form onSubmit={onSubmit} className="w-full max-w-sm space-y-5" data-testid="register-form">
          <div>
            <div className="text-xs uppercase tracking-[0.15em] text-slate-500">Registrazione</div>
            <h2 className="mt-1 text-3xl font-bold text-slate-900">{t("auto.crea_il_tuo_account")}</h2>
            <p className="mt-1 text-sm text-slate-500">{t("auto.ambiente_isolato_per_la_tua_impresa")}</p>
          </div>
          <div className="space-y-3">
            <div>
              <Label>Ragione sociale</Label>
              <Input value={form.company_name} onChange={(e) => setForm({ ...form, company_name: e.target.value })} required className="rounded-sm" data-testid="reg-company" />
            </div>
            <div>
              <Label>Nome amministratore</Label>
              <Input value={form.admin_name} onChange={(e) => setForm({ ...form, admin_name: e.target.value })} required className="rounded-sm" data-testid="reg-name" />
            </div>
            <div>
              <Label>Email amministratore</Label>
              <Input type="email" value={form.admin_email} onChange={(e) => setForm({ ...form, admin_email: e.target.value })} required className="rounded-sm" data-testid="reg-email" />
            </div>
            <div>
              <Label>{t("common.password")}</Label>
              <Input type="password" minLength={6} value={form.admin_password} onChange={(e) => setForm({ ...form, admin_password: e.target.value })} required className="rounded-sm" data-testid="reg-password" />
            </div>
          </div>
          {error && <div className="rounded-sm border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="reg-error">{error}</div>}
          <Button type="submit" disabled={loading} className="w-full rounded-sm bg-[#0052FF] py-6 text-base font-semibold hover:bg-[#0040CC]" data-testid="reg-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Crea account"}
          </Button>
          <div className="text-center text-sm text-slate-500">
            Hai già un account?{" "}
            <Link to="/login" className="font-medium text-[#0052FF] hover:underline">Accedi</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
